import base from './base'; // 导入接口域名列表
import {axiosInstance, axiosPost, axiosGet} from '@/api/http'; // 导入http中创建的axios实例
import qs from 'qs'

const api = {
    login (params) {        
        return axiosPost(`${base.url}/api/v1/user/login`,
         qs.stringify(params)
        )    
    },
    getProfile () {        
        return axiosGet(`${base.url}/api/v1/user/profile`, null)    
    },
    updatePassword (params) {        
        return axiosPost(`${base.url}/api/v1/user/updatePwd`, params)    
    },
    getUsers (params) {        
        return axiosGet(`${base.url}/api/v1/admin/user`, params)    
    },
    getHttpTraceLogs (params) {        
        return axiosGet(`${base.url}/api/v1/admin/httptrace`, params)    
    },
    getUserRegional (params) {        
        return axiosGet(`${base.url}/api/v1/admin/user/regional`, params)    
    },
    getDeviceRegional (params) {        
        return axiosGet(`${base.url}/api/v1/admin/device/regional`, params)    
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/api/api.js